const TrainingHistoryService = {
  async saveTrainingHistory(formData) {
    try {
      let url = '/api/<your_controller>';
      let method = 'PUT';
      if (formData.identifier === undefined) {
        const profileLogged = JSON.parse(localStorage.getItem('profile'));
        const { accountIdentifier } = profileLogged;
        console.log(profileLogged);
        console.log(accountIdentifier);
        url = '/api/<your_controller>';
        method = 'POST';
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newTrainingHistory = await response.json();
        console.log('TrainingHistory has been updated:', newTrainingHistory);
      }
    } catch (error) {
      console.log('Error saving TrainingHistory', error);
    }
  },
  async retrieveAllTrainingHistoryByProfile(identifier) {
    try {
      console.log('Identifier', identifier);
      const response = await fetch('/api/wod/wodclass/profile/' + identifier);
      const data = await response.json();
      console.log('Retrieved TrainingHistory data:', data);
      return data;

    } catch (error) {
      console.error('Error fetching TrainingHistory', error);
      throw error;
    }
  },
  async retrieveTrainingHistory(identifier) {
    try {
      const response = await fetch('/api/wod/wodclass/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching TrainingHistory', error);
      throw error;
    }
  },
  async deleteTrainingHistory(identifier) {
    try {
      let url = '/api/<your_controller>';
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newTrainingHistory = await response.json();
        console.log('TrainingHistory has been deleted:', newTrainingHistory);
      }
    } catch (error) {
      console.log('Error deleting TrainingHistory', error);
    }
  }
};
export default TrainingHistoryService;